<template>
  <div class="emergency-resource">
    <!--    <Card :dis-hover="true" :bordered="false" :padding="10" style="text-align: left">-->
    <!--      <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
    <!--      <Button type="primary" @click="gotoAdd" style="margin-left: 4px">新增</Button>-->
    <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导入</Button>-->
    <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导出</Button>-->
    <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">模版下载</Button>-->
    <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量删除</Button>-->
    <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量维护</Button>-->
    <!--    </Card>-->
    <Card :dis-hover="true" :bordered="false" :padding="0">
      <!--      <el-descriptions :column="1" border size="small">-->
      <!--        <el-descriptions-item label="物资大类" :label-style="{'text-align': 'right', 'width':'120px'}">-->
      <!--          <RadioGroup size="small" v-model="baseType" type="button" @on-change="tagChange">-->
      <!--            <Radio :label="0">全部</Radio>-->
      <!--            <Radio :label="1">物资类</Radio>-->
      <!--            <Radio :label="2">装备类</Radio>-->
      <!--          </RadioGroup>-->
      <!--        </el-descriptions-item>-->
      <!--        <el-descriptions-item label="设备状态" :label-style="{'text-align': 'right'}">-->
      <!--          <RadioGroup size="small" v-model="baseType" type="button" @on-change="tagChange">-->
      <!--            <Radio :label="0">全部</Radio>-->
      <!--            <Radio :label="1">正常</Radio>-->
      <!--            <Radio :label="2">预警物资</Radio>-->
      <!--            <Radio :label="3">超期物资</Radio>-->
      <!--          </RadioGroup>-->
      <!--        </el-descriptions-item>-->
      <!--        <el-descriptions-item label="行政区划" :label-style="{'text-align': 'right'}">-->
      <!--          <Row>-->
      <!--            <Col :span="6">-->
      <!--              <span>区县：</span>-->
      <!--              <Select style="width:200px">-->
      <!--                <Option value="1">德州市</Option>-->
      <!--              </Select>-->
      <!--            </Col>-->
      <!--            <Col :span="6">-->
      <!--              <span>物资名称：</span>-->
      <!--              <Input v-model="baseName" style="width:200px" ></Input>-->
      <!--            </Col>-->
      <!--            <Col :span="7">-->
      <!--              <span>仓库名称：</span>-->
      <!--              <Input v-model="baseName" style="width:200px" ></Input>-->
      <!--            </Col>-->
      <!--            <Col :span="4">-->
      <!--              <Button type="primary" @click="">查询</Button>-->
      <!--            </Col>-->
      <!--          </Row>-->
      <!--        </el-descriptions-item>-->
      <!--      </el-descriptions>-->
      <!--      <div style="text-align: center;margin-top: 10px">-->
      <!--        <Button type="primary" size="small">查询</Button>-->
      <!--        <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
      <!--      </div>-->
    </Card>
    <Row :gutter="4" style="margin-top: 10px">
      <Col :span="24">
        <Card :dis-hover="true" :padding="4" :bordered="false">
          <Table
            :loading="resLoading"
            :columns="columns"
            :data="data"
            :border="false"
            :stripe="false"
            :highlight-current-row="true"
          >
            <template #action="{ row, index }">
              <!--              <el-button size="small" type="text" @click="gotoDetail(row)">查看</el-button>-->
              <!--              <el-button size="small" type="text" @click="gotoHistory(row)">调派历史</el-button>-->
              <!--              <el-button size="small" type="text" @click="gotoSend(row)">调派</el-button>-->
              <el-button size="small" type="text" disabled
                         @click="editResource(row)">修改
              </el-button>
              <el-button size="small" type="text" disabled
                         @click="deleteResource(row)">删除
              </el-button>
            </template>
          </Table>
<!--          <Page style="text-align: right;margin-top: 10px"-->
<!--                show-sizer-->
<!--                show-total-->
<!--                transfer-->
<!--                :total="dataTotal"-->
<!--                :page-size="pageSize"-->
<!--                :page-size-opts="pageSizeOpts"-->
<!--                :current-page="currentPage"-->
<!--                @on-change="pageChange"-->
<!--                @on-page-size-change="pageSizeChange"-->
<!--          ></Page>-->
        </Card>
      </Col>
    </Row>

    <Modal title="编辑" width="512" :mask-closable="false" v-model="editRes" :footer-hide="true" :styles="{top: '0px'}">
      <add-em-resource @closeModal="modalClose" :status="'edit'" :formValidate="selectRow"></add-em-resource>
    </Modal>
  </div>
</template>

<script>
import AddEmResource from '@/views/Resources/emergencyResource/addEmResource/addEmResource.vue'

export default {
  name: "emergencyResource",
  components: {AddEmResource},
  props: {
    belongStore: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    },
    resLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editRes: false,
      selectBaseId: 0,
      selectRow: {},
      baseType: 0,
      baseName: '',
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '物资名称',
          align: 'center',
          key: 'name'
        },
        {
          title: '数量',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.number}${params.row.unit}`)
          }
        },
        // {
        //   title: '标准数量',
        //   align: 'center',
        //   // width: '130',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         // textAlign: 'left'
        //       }
        //     }, `${params.row.goodsConfigNumber}${params.row.unit}`)
        //   },
        // },
        // {
        //   title: '有效日期',
        //   align: 'center',
        //   // width: '130',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         // textAlign: 'left'
        //       }
        //     }, params.row.effectiveDate === null ? '' : this.$moment(params.row.effectiveDate).format('YYYY-MM-DD'))
        //   },
        // },
        {
          title: '物资类型',
          align: 'center',
          key: 'applicableEventName'
        },
        {
          title: '备注',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.remark)
          },
        },
        {
          width: '100',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      // data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: ''
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          // console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        // console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.selectBaseId = this.belongStore
    // this.getEmergencyResource()
  },
  methods: {
    gotoAdd() {
      this.$router.push({
        name: 'addEmResource',
      })
    },
    editResource(row) {
      // console.log(row)
      this.selectRow = row
      this.editRes = true
      // this.selectBaseId = Number(row.id)
      // this.$router.push({
      //   name: 'addEmResource',
      //   params: {
      //     row: row
      //   }
      // })
    },
    deleteResource(row) {
      this.$emit('deleteResource', row)
    },
    modalClose(data) {
      this.editRes = false
      this.selectBaseId = data
      this.getEmergencyResource()
    },
    gotoDetail(row) {
      this.$router.push({
        name: 'emResourceDetail',
        params: {
          row: row
        }
      })
    },
    gotoSend(row) {
      this.$router.push({
        name: 'sendResource',
        params: {
          row: row
        }
      })
    },
    gotoHistory(row) {
      this.$router.push({
        name: 'sendProHistory',
        params: {
          row: row
        }
      })
    },
    getEmergencyResource() {
      // this.dataLoading = true
      this.$http.get(`/api/goods/getGoods/${this.selectBaseId}`).then(res => {
        // console.log(res)
        this.data = res.data.data
        // this.data = res.data.data.list
         this.dataTotal = res.data.total
        // this.dataLoading = false
      })
    },
    tagChange(value) {
      // console.log(value)
      // this.getEmergencyTeams()
    },
    pageChange(page) {
      this.currentPage = page
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
    },
  }
}
</script>

<style scoped lang="less">
.emergency-resource {
  .ivu-radio-group-item {
    margin-left: 16px;
  }
}
</style>
